<div class="dialog-main">
  <ng-template #backButtonRef>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button pointer-cursor"
      (click)="closeDialog()"
    />
  </ng-template>
  <ng-container *ngIf="stepper === 0">
    <app-physical-credential-confirm-dialog
      [dialogRef]="dialogRef"
      [title]="userDetail?.title"
      [name]="userDetail?.userName"
      [bodyText]="'ARE_YOU_SURE_YOU_WANT_TO_REMOVE_USER' | translate"
      [footerText]="'BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO_USER' | translate"
      [confirmBtn]="'YES' | translate"
      [cancelBtn]="'NO' | translate"
      [isCardActive]="userDetail?.isCardActive"
      [(stepper)]="stepper"
      (deleteUserEmitter)="deleteUserEmitter()"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-physical-credential-confirm-dialog>
  </ng-container>

  <ng-container *ngIf="stepper === 1">
    <app-physical-credential-confirm-dialog
      [dialogRef]="dialogRef"
      [title]="userDetail?.title"
      [name]="userDetail?.userName"
      [bodyText]="'BEFORE_YOU_DELETE_THIS_USER' | translate"
      [footerText]="
        'TO_DELETE_THIS_USER_PLEASE_ENSURE_PHYSICAL_CREDENTIALS' | translate
      "
      [confirmBtn]="'CREDENTIALS_ARE_RETRIEVED' | translate"
      [cancelBtn]="'ADD_TO_BLOCK_LIST' | translate"
      (stepperChange)="changeStepper($event)"
      [isCardActive]="userDetail?.isCardActive"
      [(stepper)]="stepper"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-physical-credential-confirm-dialog>
  </ng-container>

  <ng-container *ngIf="stepper === 2">
    <app-physical-credential-confirm-dialog
      [dialogRef]="dialogRef"
      [title]="userDetail?.title"
      [name]="userDetail?.userName"
      [bodyText]="'BLOCK_LIST_REQUIRES_MOBILE_APP' | translate"
      [footerText]="'PHYSICAL_CREDENTIALS_BLOCK_LIST' | translate"
      [cancelBtn]="'CLOSE' | translate"
      (stepperChange)="changeStepper($event)"
      [isCardActive]="userDetail?.isCardActive"
      [(stepper)]="stepper"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-physical-credential-confirm-dialog>
  </ng-container>
</div>
